import { Routes, Route } from "react-router-dom";

import Settings from "./Settings";
import Onboarding from "./Onboarding";
import Installation from "./Installation";
import DataBackfill from "./DataBackfill";
import Forbidden from "./Forbidden";
import ServerError from "./ServerError";
import NotFound from "./NotFound";
import SelectInitialRoute from "./SelectInitialRoute";

const Routess = () => {
  return (
    <Routes>
      <Route path="/" element={<SelectInitialRoute />} />
      <Route path="onboarding" element={<Onboarding />} />
      <Route path="settings/new" element={<Installation />} />
      <Route path="synchronizations/new" element={<DataBackfill />} />
      <Route path="settings/edit" element={<Settings />} />
      <Route path="forbidden" element={<Forbidden />} />
      <Route path="internal-server-error" element={<ServerError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routess;
